import { render, staticRenderFns } from "./soliderInfo.vue?vue&type=template&id=1a8547e4&scoped=true&"
import script from "./soliderInfo.vue?vue&type=script&lang=js&"
export * from "./soliderInfo.vue?vue&type=script&lang=js&"
import style0 from "./soliderInfo.vue?vue&type=style&index=0&id=1a8547e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8547e4",
  null
  
)

export default component.exports